import type { AxiosError } from "axios";
import i18n from "@/i18n";

const { t } = i18n.global;

const STATUS_MESSAGES: Record<number, string> = {
  401: t("errors.unauthorized"),
  409: t("errors.userAlreadyExists"),
  422: t("errors.validationError"),
  500: t("errors.serverError"),
};

export function handleAxiosError(
  error: unknown, 
  defaultMessage?: string,
  customMessages?: Record<number, string>
): string {
  const err = error as AxiosError<{ detail?: string }>;

  if (!err.response) return t("errors.network");

  const status = err.response.status;
  return customMessages?.[status] 
    || STATUS_MESSAGES[status] 
    || err.response.data?.detail 
    || defaultMessage 
    || t("errors.unknownError");
}

export function handlePasswordResetError(error: unknown): string {
  return handleAxiosError(error, t("errors.passwordResetFailed"), {
    422: t("errors.passwordRequirements")
  });
}

export function handleUserManagementError(
  error: unknown,
  operation: "create" | "disable" | "enable" | "changePassword"
): string {
  const messages = {
    create: t("errors.userCreateFailed"),
    disable: t("errors.userDisableFailed"),
    enable: t("errors.userEnableFailed"),
    changePassword: t("errors.passwordGenerateFailed"),
  };
  return handleAxiosError(error, messages[operation]);
}
